module.exports = __webpack_public_path__ + "assets/img/solar-panels-11-small.d19661d4.jpg";